<template>
  <el-main class="page-content-margin-unset">
    <h3 v-if="body.user_info">用户信息</h3>
    <div class="detail" v-if="body.user_info">
      <el-form
        :inline="false"
        status-icon
        label-position="left"
        label-width="120px"
        class="demo-ruleForm">
        <el-form-item
          v-if="body.user_info"
          class="dk-input"
          label="头像:">
          <img
            :src="body.user_info.avatar"
            width="141px">
        </el-form-item>
        <el-form-item
          v-if="body.user_info"
          class="dk-input"
          label="用户名称:">
          <span>{{ body.user_info.nickname }}</span>
        </el-form-item>
        <el-form-item
          v-if="body.user_info"
          class="dk-input"
          label="手机号:">
          <span>{{ body.user_info.mobile}}</span>
        </el-form-item>
      </el-form>
    </div>
    <h3>案例信息</h3>
    <div>
      <el-form
        :model="body"
        status-icon
        label-position="left"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm">
        <el-form-item
          label="*案例名称"
          prop="name">
          <el-input
            class="dk-input"
            v-model="body.name"/>
        </el-form-item>
        <el-form-item
          label="*排序"
          prop="priority">
          <el-input
            class="dk-input"
            v-model="body.priority"/>
        </el-form-item>
        <el-form-item
          label="*关联品牌"
          prop="price">
          <div v-for="(uuid, index) in body.brand_uuid">
            <el-select v-model="body.brand_uuid[index]" filterable placeholder="请选择">
              <el-option
                v-for="item in brandList"
                :key="item.uuid"
                :label="item.name"
                :value="item.uuid">
              </el-option>
            </el-select>
                <i v-if="index === 0"
                   class="el-icon-circle-plus-outline"
                   style="font-size: 20px;"
                   @click="event().plusClick()"></i>
                <i v-if="index !== 0"
                   class="el-icon-remove-outline"
                   style="font-size: 20px;"
                   @click="event().reduceClick(index)"></i>
          </div>
        </el-form-item>
        <el-form-item
          label="风格"
          prop="style">
          <el-select v-model="body.style_uuid" filterable placeholder="请选择">
            <el-option
              v-for="item in styleList"
              :key="item.uuid"
              :label="item.name"
              :value="item.uuid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="*城市"
          prop="city">
          <el-cascader
            v-model="city"
            :options="cityList"
            :show-all-levels="false"
            :disabled="cityDisabled"
            :props="{ value: 'name',label:'name',children:'districts', checkStrictly: true }"
            filterable></el-cascader>
          <el-checkbox @change="event().checkboxChange()" v-model="other" >其他</el-checkbox>
        </el-form-item>
        <el-form-item
          label="*封面图"
          prop="index_img">
          <upload-img v-model="index_img_data" :prop="{ key: 'index_img', url: 'index_img_url' }" :label="'封面图'" />
        </el-form-item>
        <h3>案例详情</h3>
        <el-form-item
          label="*图片(1-8张)"
          prop="img_list">
          <el-upload
            :action="uploadDomain"
            :multiple="false"
            :limit="8"
            :file-list="imgList"
            :on-success="onImageUploadSuccessDetail"
            :on-remove="removeImgDetail"
            :on-preview="handlePictureCardPreview"
            :on-exceed="onImageLimitedDetail"
            :data="uploadData"
            :before-upload="beforeAvatarUploadDetail"
            list-type="picture-card"
            style="display:inline-block">
            <i class="el-icon-plus"/>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img
              width="100%"
              :src="dialogImageUrl"
              alt="">
          </el-dialog>
        </el-form-item>
        <el-form-item label="*案例说明">
          <el-input
            class="dk-input"
            type="textarea"
            v-model="body.content" />
        </el-form-item>
        <el-form-item>
          <el-button @click="event().toBrackClick()">返 回</el-button>
          <el-button
            type="primary"
            @click="event().onSureClick('ruleForm')">保存</el-button>
        </el-form-item>
      </el-form>
    </div>

  </el-main>
</template>

<script>
import {
  getStyle, getCity, addExample, editExample, getBrand, getExampleDetail,
} from '../../api/case'
import { uploadDomain } from '../../configs/env'
import uploadImg from '../../components/form/uploadImg'
import qiniu from '../../jslib/qiniu'

export default {
  mixins: [qiniu],
  data() {
    return {
      uploadDomain,
      levelDialog: false,
      levelTitle: '添加规格',
      body: {
        style: '',
        style_uuid: '',
        brand_uuid: [''],
        name: '',
        index_img: '',
        img_list: [],
        del_brand_uuid: [],
        content: '',
      },
      city: [],
      styleList: [],
      cityList: [],
      brandList: [],
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: '',
      imgList: [],
      index_img_data: {
        index_img: '',
        index_img_url: '',
      },
      other: false,
      cityDisabled: false,
    };
  },
  created() {
    this.network().getStyle()
    this.network().getCity()
    this.network().getBrand()
    if (!this.$route.query.uuid) return
    this.network().getExampleDetail(this.$route.query.uuid)
  },
  methods: {
    event() {
      return {
        checkboxChange: () => {
          this.$set(this, 'cityDisabled', this.other)
        },
        plusClick: () => {
          this.body.brand_uuid.push("")
        },
        reduceClick: (index) => {
          this.body.del_brand_uuid.push(this.body.brand_uuid[index])
          this.body.brand_uuid.splice(index,1)
        },
        toBrackClick: () => {
          this.$router.go(-1)
        },
        onSureClick: (formName) => {
          if (this.body.content.length < 20 || this.body.content.length > 1000) {
            this.$message.warning('案例说明应在20-1000字之间');
            return false;
          }
          if (!this.$route.query.uuid) {
            if (this.other == true) {
              this.body.city = '其他'
            }else if (this.city != '') {
              this.body.city = this.city[1]
            }
            this.body.index_img = this.index_img_data.index_img
            this.network().addExample();
            // console.log(this.city);
          } else {
            if (this.other == true) {
              this.body.city = '其他'
            }else if (this.city != '') {
              this.body.city = this.city[1]
            }
            this.body.index_img = this.index_img_data.index_img
            this.body.uuid = this.$route.query.uuid
            this.network().editExample();
          }
        },
      }
    },
    network() {
      return {
        getBrand: async () => {
          const { status, data } = await getBrand()
          if (status !== 200) return
          this.brandList = data.data
        },
        getStyle: async () => {
          const { status, data } = await getStyle()
          if (status !== 200) return
          this.styleList = data.data
        },
        getCity: async () => {
          const { status, data } = await getCity()
          if (status !== 200) return
          for (let item of data) {
            for (let i of item.districts) {
              delete i.districts
            }
          }
          this.cityList = data
        },
        getExampleDetail: async () => {
          const { status, data } = await getExampleDetail({'uuid': this.$route.query.uuid})
          if (status !== 200) return
          this.index_img_data.index_img = data.index_img
          this.index_img_data.index_img_url = this.imgDomain + data.index_img
          this.$set(this, 'brandList', this.brandList.concat(data.brand))
          console.log(data.img_list)
          for(let item of data.img_list) {
            this.imgList.push({
              response: { key: item },
              url: this.imgDomain + item,
            })
          }
          console.log(this.imgList)
          this.body = { ...this.body, ...data }
          console.log(this.body)
          const { status: status2, data: cityList } = await getCity()
          if (status2 !== 200) return
          const city = []
          for (let item of cityList) {
            for(let i of item.districts) {
              if (i.name === this.body.city) {
                city[0] = item.name
                city[1] = i.name
              }
            }
          }
          this.city = city
          // this.$set(this, 'city', city)
          if (this.body.city == '其他') {
            this.$set(this, 'other', true)
            this.$set(this, 'cityDisabled', this.other)
          }
        },
        addExample: async () => {
          const { status } = await addExample(this.body)
          if (status !== 200) return
          this.$notify({
            title: '新增成功',
            message: '新增案例成功',
            type: 'success',
          });
          this.$router.go(-1)
        },
        editExample: async () => {
          const { status } = await editExample(this.body)
          if (status !== 200) return
          this.$notify({
            title: '编辑成功',
            message: '编辑案例成功',
            type: 'success',
          });
          this.$router.go(-1)
        },
      }
    },
    handler() {
      return {
      }
    },
    handleCurrentChange() {
    },
    // 覆盖element-ui的上传动作
    onImageChange() {
    },
    // 放大
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    // 详情图
    onImageLimitedDetail() {
      this.$message.error('最多上传八张图片')
    },
    beforeAvatarUploadDetail(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        testmsg === "jpg" ||
        testmsg === "JPG" ||
        testmsg === "png" ||
        testmsg === "PNG" ||
        testmsg === "bpm" ||
        testmsg === "jpeg" ||
        testmsg === "BPM";

      if (!extension) {
        this.$message.warning('上传图片只能是jpg / png / bpm格式!');
        return false;
      }

      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      this.beforeAvatarUploadImages(file)
      return isLt2M;
    },
    onImageUploadSuccessDetail(response, fileList, file) {
      console.log(fileList)
      this.imgList.push({
        response: {
          key: response.key,
        }, // response里面的key是必须的
        url: this.imgDomain + response.key, // url也是必须的
      })
      this.body.img_list.push(response.key)
    },
    removeImgDetail(file, fileList) {
      this.imgList = fileList // 剩下的文件
      // eslint-disable-next-line
      let arr = []
      fileList.forEach((item) => {
        arr.push(item.response.key)
      })
      this.body.img_list = arr
    },
  },
  components: {
    uploadImg,
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/styles/mixins.scss';
.page-content-margin-unset{
  .dk-from{
    display: flex;
  }
  .table-top{
    @include dk-table-top;
  }
}
</style>



// WEBPACK FOOTER //
// src/vuepage/case/case-add.vue